import React, { useEffect, useState } from "react";
import Layout from "../../../Main/RegistrationLayout";
import FormFactory from "../../../../components/FormFactory";
import Notification from "../../../../components/Notification";
import RegistrationTemplate from "../../../../components/RegistrationTemplate";
import { Form } from "antd";
import { getConfig } from "../../../../hooks/use-config";
import { formDataFields } from "./formData";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import useUser from "../../../../features/profile/useUser";
import {
  logoutUser,
  setTraceIdForIdentification,
} from "../../../../redux/reducers/user-authentication/authentication-action";
import {
  getSubmissionData,
  getUpdatedData,
} from "../../../Registration/hooks/use-helpers";
import HexLoader from "../../../../components/HexLoader";
import PrimaryButton from "../../../../ui-kit/HexButtons/PrimaryButton";
import {
  identificationTraceId,
  IdentityVerficationOtpTraceId,
} from "../../../Registration/lib/api";
import { deleteConsumerProfile } from "../../api-handler";
import HexAuthWrapper from "../../../../components/HexAuthWrapper";

const DeleteUser = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const traceId = useSelector((state) => state.authentication.traceId);
  const { phoneNumber: userPhoneNumber } = useUser();
  const [phoneNumber, setPhoneNumber] = useState("");

  useEffect(() => {
    !traceId && navigate("/account-settings");
  }, [traceId, navigate]);

  useEffect(() => {
    if (userPhoneNumber) setPhoneNumber(userPhoneNumber);
  }, [userPhoneNumber]);

  const deleteConfigs = formDataFields()["delete-account"];
  const { title, text, fields, subTitle, footerText, alert, icon } =
    deleteConfigs;

  const codeInfo = {
    title,
    subTitle,
    footerText,
    icon,
    alertText: alert,
  };

  const [form] = Form.useForm();
  const [errors, setErrors] = useState({});
  const [formFields, setFormFields] = useState(fields);
  const [notification, setNotification] = useState("");
  const [resendOtpTime] = useState(30);

  const onChangeHandler = (value, key) => {
    const { updateFormFields, errors } = getUpdatedData(formFields, value, key);
    setFormFields(updateFormFields);
    setErrors(errors);
    notification && setNotification("");
  };

  const formSubmitDataHandler = () => {
    const { required, fieldData } = getSubmissionData(formFields);

    if (Object.keys(required).length) {
      setErrors(required);
    } else {
      return fieldData;
    }
  };

  const onFinishHandler = () => {
    const formData = formSubmitDataHandler();
    onSubmit(formData);
  };

  const onKeyPress = (event) => {
    if (event.key === "Enter") {
      onFinishHandler();
    }
  };

  const onSubmit = (formData) => {
    if (formData) {
      const { otp } = formData;
      setLoading(true);
      IdentityVerficationOtpTraceId(traceId, otp, (error, data) => {
        if (!error) {
          const { traceId } = data;
          deleteConsumerHandler(traceId);
        } else {
          const { debugMessage, errorCode } = error;
          const message = getConfig(errorCode);
          message ? setNotification(message) : setNotification(debugMessage);
          setLoading(false);
        }
      });
    }
  };

  const deleteConsumerHandler = (traceId) => {
    deleteConsumerProfile(traceId)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          dispatch(logoutUser());
          navigate("/");
        }
      })
      .catch((error) => {
        const { debugMessage, errorCode } = error;
        const message = getConfig(errorCode);
        message ? setNotification(message) : setNotification(debugMessage);
        setLoading(false);
      });
  };

  const resendOtpHandler = () => {
    identificationTraceId(phoneNumber).then((response) => {
      const { traceId } = response;
      dispatch(setTraceIdForIdentification(traceId));
    });
  };

  return (
    <HexAuthWrapper>
      <Layout className="delete-container" viewHeight={true} blurSpots={true}>
        <RegistrationTemplate
          containerName="delete-container"
          sectionName="delete-consumer"
          configs={codeInfo}
          headerLogo={true}
          goBack={true}
          footerLogo={true}
        >
          <div className="delete-container__listing">
            <Form layout="vertical" form={form} onFinish={onFinishHandler}>
              <FormFactory
                formElementsTypes={formFields}
                onChangeHandler={onChangeHandler}
                errors={errors}
                resendOtp={resendOtpHandler}
                resendOtpTime={resendOtpTime}
                onKeyPress={onKeyPress}
              />
            </Form>
          </div>
          {notification && (
            <Notification type="danger" message={notification} />
          )}

          {loading ? (
            <HexLoader />
          ) : (
            <div className="delete-container__btn">
              {
                <PrimaryButton
                  label={text}
                  onClick={() => form.submit()}
                  type="primary"
                  size="lg"
                />
              }
            </div>
          )}
        </RegistrationTemplate>
      </Layout>
    </HexAuthWrapper>
  );
};

export default DeleteUser;
